import { handleSendFunctionResponseToShotListAgent } from "../services/handleSendFunctionResponseToShotListAgent";
import { addIdentifierToShots } from "./addIdentifierToShots";
import { updateShotListHistory } from "./updateShotListHistory";

export const deleteShot = async (
  { identifier, confirm },
  chatSession,
  shotListState,
  setShotListState,
  setChatSession,
  userInfo,
  setModalOpen,
  setModalTitle,
  setModalDescription,
  setModalOnConfirm,
  setModalOnCancel,
  setModalCancelButtonText,
  setModalConfirmButtonText,
  shotListHistory,
  setShotListHistory,
  historyIndex,
  setHistoryIndex,
  setModalChildren,
  modalChildren
) => {
  // Find the shot to delete
  const shotToDelete = shotListState.find(shot => shot.identifier === identifier);
  
  if (!shotToDelete) {
    const responseMessage = `FunctionResponse: Shot #${identifier} not found.`;
    const response = {
      role: "user",
      parts: [{ text: responseMessage }]
    };
    await handleSendFunctionResponseToShotListAgent(response, chatSession, setChatSession, userInfo);
    return;
  }

  // Show modal for confirmation
  setModalTitle("Delete Shot");
  setModalCancelButtonText("Cancel");
  setModalConfirmButtonText("OK");
  
  // Format shot information in a more presentable way
  const shotInfo = Object.entries(shotToDelete)
    .filter(([key]) => key !== 'identifier') // Exclude identifier
    .map(([key, value]) => {
      // Format keys nicely
      const displayKey = key.replace(/([A-Z])/g, ' $1').trim();
      return `• ${displayKey}:
  ${value || '—'}`;
    })

  setModalDescription(
    `Are you sure you want to delete this shot?\n\n`
  );
  setModalChildren(<div> <br/> {shotInfo.map(info => <div key={info}>{info}</div>)} </div>);
  
  setModalOpen(true);

  setModalOnConfirm(() => async () => {
    setModalOpen(false);
    const updatedShotListState = addIdentifierToShots(shotListState.filter(shot => shot.identifier !== identifier));
    updateShotListHistory(
      shotListState,
      setShotListState,
      shotListHistory,
      setShotListHistory,
      historyIndex,
      setHistoryIndex,
      updatedShotListState
    );

    setShotListState(updatedShotListState);

    const responseMessage = `FunctionResponse: Shot #${identifier} has been deleted. Here is the updated shot list: ${JSON.stringify(updatedShotListState, null, 2)}.`;
    const response = {
      role: "user",
      parts: [{ text: responseMessage }]
    };
    await handleSendFunctionResponseToShotListAgent(response, chatSession, setChatSession, userInfo);
  });

  setModalOnCancel(() => () => {
    setModalOpen(false);
    const responseMessage = `FunctionResponse: Deletion cancelled. No shots were deleted.`;
    const response = {
      role: "user",
      parts: [{ text: responseMessage }]
    };
    handleSendFunctionResponseToShotListAgent(response, chatSession, setChatSession, userInfo);
  });
};